import { Name } from "../models/Name";
import { APIConnector } from "./api/APIConnector";
import { Deserializer } from 'jsonapi-serializer';
import { PaginationModel } from "../models/Pagination";
import { createPagination } from "./utilities/paginationBuilder";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { INTERNAL_SERVER_ERROR } from "../constants/response-status-codes";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";

const apiConnector = new APIConnector();

export const getLocationTypeNames = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filter = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `locationType?fields[locationType]=ltName${paginationString}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, items: any[]) => {
                if (err) {
                    return reject({ status: response.status, message: genericError });
                }

                const locationTypes: Name[] = items.map((locationType): Name => {
                    return {
                        value: locationType['id'],
                        label: locationType['lt-name']
                    };
                });

                return resolve({ rows: locationTypes, pagination: newPagination });
            })
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
